import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding-bottom: 40px;
`;

/* ─────────────────────────────────────────
   HERO HEADER
───────────────────────────────────────── */
export const HeroHeader = styled.section`
  position: relative;
  background: linear-gradient(160deg, #13082a 0%, #0f0f1f 55%, #0a0a12 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  padding: 30px 24px 0;
  overflow: hidden;

  /* Decorative glow orbs */
  &::before {
    content: '';
    position: absolute;
    top: -60px;
    right: -60px;
    width: 260px;
    height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(147,51,234,0.18) 0%, transparent 70%);
    pointer-events: none;
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 80px;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(88,101,242,0.12) 0%, transparent 70%);
    pointer-events: none;
  }

  .header-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    position: relative;
  }

  .title-block {
    .label {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 10.5px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #a78bfa;
      background: rgba(147, 51, 234, 0.14);
      border: 1px solid rgba(147, 51, 234, 0.28);
      padding: 3px 10px;
      border-radius: 20px;
      margin-bottom: 10px;

      .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #a78bfa;
        animation: pulse 1.8s ease-in-out infinite;
      }

      @keyframes pulse {
        0%, 100% { opacity: 1; transform: scale(1); }
        50%       { opacity: 0.4; transform: scale(0.7); }
      }
    }

    .page-title {
      font-size: 24px;
      font-weight: 800;
      color: #f1f5f9;
      margin-bottom: 6px;
      display: flex;
      align-items: center;
      gap: 10px;
      line-height: 1.2;

      svg { color: #9333EA; font-size: 22px; }
    }

    .page-sub {
      font-size: 13px;
      color: #6b7280;
      line-height: 1.6;
    }
  }

  .add-server-btn {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 11px 20px;
    background: #9333EA;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    flex-shrink: 0;
    align-self: flex-start;
    transition: background 0.18s, transform 0.15s;

    &:hover {
      background: #6d28d9;
      transform: translateY(-1px);
    }

    svg { font-size: 15px; }
  }

  /* ── Stats strip ── */
  .stats-strip {
    display: flex;
    align-items: center;
    gap: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    position: relative;

    .stat-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 13px 20px;
      border-left: 1px solid rgba(255, 255, 255, 0.06);

      &:last-child { border-left: none; }

      .stat-icon {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        flex-shrink: 0;
      }

      .stat-text {
        .stat-value {
          font-size: 15px;
          font-weight: 800;
          color: #f1f5f9;
          line-height: 1.2;
        }
        .stat-label {
          font-size: 10.5px;
          color: #6b7280;
        }
      }
    }
  }
`;

/* ─────────────────────────────────────────
   TABS (servers / archive)
───────────────────────────────────────── */
export const TabBar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 20px;
  background: #111;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);

  button {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 13px 16px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    color: #6b7280;
    font-size: 13px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;
    transition: color 0.18s, border-color 0.18s;

    svg { font-size: 14px; }

    &.active {
      color: #e2e8f0;
      border-color: #9333EA;
      svg { color: #a78bfa; }
    }

    &:hover:not(.active) { color: #9ca3af; }
  }
`;

/* ─────────────────────────────────────────
   CONTROLS BAR (search + filters + view)
───────────────────────────────────────── */
export const ControlsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  background: #111;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-wrap: wrap;

  .search-wrap {
    position: relative;
    flex: 1;
    min-width: 160px;

    svg {
      position: absolute;
      inset-inline-start: 11px;
      top: 50%;
      transform: translateY(-50%);
      color: #4b5563;
      font-size: 14px;
      pointer-events: none;
    }

    input {
      width: 100%;
      background: #1A1A1A;
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 8px;
      padding-block: 9px;
      padding-inline-start: 34px;
      padding-inline-end: 14px;
      color: #e2e8f0;
      font-size: 13px;
      font-family: inherit;
      outline: none;
      transition: border-color 0.2s;

      &::placeholder { color: #4b5563; }
      &:focus { border-color: rgba(147, 51, 234, 0.5); }
    }
  }

  .filter-group {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }

  .view-toggle {
    display: flex;
    align-items: center;
    gap: 2px;
    background: #1A1A1A;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 3px;
    flex-shrink: 0;

    button {
      width: 32px;
      height: 32px;
      border: none;
      border-radius: 6px;
      background: transparent;
      color: #6b7280;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      transition: background 0.15s, color 0.15s;

      &.active {
        background: #9333EA;
        color: #fff;
      }

      &:hover:not(.active) {
        background: rgba(255, 255, 255, 0.06);
        color: #e2e8f0;
      }
    }
  }
`;

export const FilterBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  border-radius: 20px;
  border: 1px solid ${props => props.active ? '#9333EA' : 'rgba(255,255,255,0.08)'};
  background: ${props => props.active ? 'rgba(147,51,234,0.18)' : 'transparent'};
  color: ${props => props.active ? '#a78bfa' : '#6b7280'};
  font-size: 12px;
  font-weight: ${props => props.active ? '600' : '500'};
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.18s;

  svg { font-size: 12px; }

  &:hover {
    border-color: rgba(147, 51, 234, 0.4);
    color: #e2e8f0;
  }
`;

/* ─────────────────────────────────────────
   GRID & CARDS
───────────────────────────────────────── */
export const ServersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  padding: 18px 20px;

  @media (max-width: 1000px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 720px)  { grid-template-columns: repeat(2, 1fr); }

  &.list-view {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

export const ServerCard = styled.div`
  background: #1A1A1A;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  display: block;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.04);
  transition: border-color 0.18s, transform 0.15s, box-shadow 0.18s;

  &:hover {
    border-color: rgba(147, 51, 234, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }

  /* ── LIST VIEW variant ── */
  &.list-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;

    &:hover { transform: translateX(-2px); }

    .card-img-wrap {
      width: 130px;
      min-width: 130px;
      aspect-ratio: 16 / 9;
      border-radius: 0;
    }

    .card-body {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 10px 14px;

      .card-top-row { margin-bottom: 0; flex: 1; }
      .card-right-col { display: flex; align-items: center; gap: 14px; flex: 1; }
      .card-name { margin-bottom: 0; white-space: nowrap; }
      .card-stats { margin-bottom: 0; }
      .card-level { margin-bottom: 0; }
    }

    .website-btn { margin: 0; flex-shrink: 0; }
  }

  /* ── IMAGE ── */
  .card-img-wrap {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    background: #0d0d1b;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.4s;
    }

    &:hover img { transform: scale(1.04); }

    .age-badge {
      position: absolute;
      top: 7px;
      inset-inline-start: 7px;
      font-size: 9.5px;
      font-weight: 800;
      padding: 2px 8px;
      border-radius: 4px;
      color: #fff;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      pointer-events: none;

      &.badge-hot     { background: linear-gradient(135deg, #ef4444, #f97316); box-shadow: 0 2px 8px rgba(239,68,68,0.4); }
      &.badge-new     { background: #9333EA; box-shadow: 0 2px 8px rgba(147,51,234,0.4); }
      &.badge-rising  { background: #3b82f6; box-shadow: 0 2px 8px rgba(59,130,246,0.4); }
      &.badge-month   { background: #0d9488; box-shadow: 0 2px 8px rgba(13,148,136,0.4); }
      &.badge-veteran { background: linear-gradient(135deg, #f59e0b, #d97706); box-shadow: 0 2px 8px rgba(245,158,11,0.4); }
    }

    .time-badge {
      position: absolute;
      bottom: 7px;
      inset-inline-start: 7px;
      background: rgba(0, 0, 0, 0.72);
      color: #d1d5db;
      font-size: 9.5px;
      padding: 3px 8px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      gap: 4px;

      svg { font-size: 9px; color: #9ca3af; }
    }
  }

  /* ── BODY ── */
  .card-body {
    padding: 9px 11px 11px;
    direction: rtl;
  }

  .card-top-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 3px;
  }

  .card-right-col { flex: 1; min-width: 0; }

  .card-left-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    padding-top: 2px;
  }

  .card-likes {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #9ca3af;
    font-size: 11.5px;
    direction: ltr;

    svg { color: #e2e8f0; font-size: 13px; }
  }

  .platform-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: #5865f2;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    box-shadow: 0 2px 8px rgba(88, 101, 242, 0.4);
  }

  .card-name {
    font-size: 12.5px;
    font-weight: 700;
    color: #f1f5f9;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .card-stats {
    font-size: 11px;
    color: #9ca3af;
    margin-bottom: 2px;
  }

  .card-level {
    font-size: 11px;
    color: #9ca3af;
    margin-bottom: 6px;
  }

  .card-owner {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
  }

  .owner-label {
    font-size: 11px;
    color: #9ca3af;
  }

  .fame-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 9.5px;
    font-weight: 800;
    padding: 2px 8px;
    border-radius: 4px;
    letter-spacing: 0.02em;

    svg { font-size: 9.5px; }

    &.known { background: rgba(59, 130, 246, 0.92); color: #fff; }
    &.famous { background: linear-gradient(135deg, #e8c05a 0%, #c09136 50%, #8a6520 100%); color: #1a1305; }
    &.unknown { background: rgba(156, 163, 175, 0.92); color: #fff; }
  }

  .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: rgba(22, 163, 74, 0.18);
    color: #4ade80;
    border: 1px solid rgba(74, 222, 128, 0.28);
    font-size: 10.5px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 4px;
    line-height: 1.5;
    font-family: inherit;

    .online-dot {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #4ade80;
    }
  }

  .website-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: fit-content;
    margin: 10px auto 0;
    padding: 8px 14px;
    background: linear-gradient(135deg, #e8c05a 0%, #c09136 50%, #8a6520 100%);
    border: none;
    border-radius: 6px;
    color: #fff;
    font-size: 11.5px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;
    transition: filter 0.18s;

    svg { font-size: 12px; }
    &:hover { filter: brightness(0.88); }
  }
`;

/* ─────────────────────────────────────────
   PAGINATION
───────────────────────────────────────── */
export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  flex-wrap: wrap;
  gap: 10px;

  .page-info {
    font-size: 12.5px;
    color: #6b7280;

    span { color: #9ca3af; font-weight: 600; }
  }

  .pages {
    display: flex;
    align-items: center;
    gap: 4px;
    direction: ltr;
  }
`;

export const PageBtn = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid ${props => props.active ? '#9333EA' : 'rgba(255,255,255,0.08)'};
  background: ${props => props.active ? '#9333EA' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#9ca3af'};
  font-size: 13px;
  font-weight: ${props => props.active ? '700' : '400'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.35 : 1};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  transition: all 0.15s;

  &:hover:not(:disabled) {
    border-color: rgba(147, 51, 234, 0.5);
    color: #e2e8f0;
    background: ${props => props.active ? '#9333EA' : 'rgba(147,51,234,0.1)'};
  }
`;
